import { connect } from 'react-redux';
import HomePage from './component';
import {
  getRachelDashboard,
  requestPaymentReportingHistory,
  requestPaymentReportingStatus,
  requestPaymentReportingStatusWithCreditTracking,
} from '@renter-hub/actions/requests';
import { showPageNotification } from '@common/actions/NotificationActions';
import { checkRequestActionSuccess, getSignInPage } from '@common/paymentsUtils/api';
import { DEFAULT_ERROR } from '@renter-hub/constants/notifications';
import HTTP_STATUS from '@common/constants/HttpConstants';
import paths from '@renter-hub/pathsManifest';
import { ErrorInterface } from '@common/types';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state) => ({
  ...state.payments.renter.dashboard,
  location: state.router.location,
  config: state.payments.renter.config,
});

const mapDispatchToProps = (dispatch, { brand, inviteToken }) => ({
  requestRenterStatus: async () => {
    try {
      // Request the latest renter status
      const [renterStatusResponse] = await dispatch(getRachelDashboard({ encryptedInvite: inviteToken }));
      await checkRequestActionSuccess(renterStatusResponse);
      const { enableCreditReporting, enableCreditTracking } = renterStatusResponse.payload.renterStatus;

      if (enableCreditReporting) {
        const { rentTermsKey } = renterStatusResponse.payload.renterStatus.rentTerms;
        if (rentTermsKey) {
          const rentReportingStatus = enableCreditTracking
            ? await dispatch(requestPaymentReportingStatusWithCreditTracking(rentTermsKey))
            : await dispatch(requestPaymentReportingStatus(rentTermsKey));
          await checkRequestActionSuccess(rentReportingStatus);
          const paymentReportHistory = await dispatch(requestPaymentReportingHistory(rentTermsKey));
          await checkRequestActionSuccess(paymentReportHistory);
        }
      }
      return { error: false };
    } catch (err) {
      const error = err as ErrorInterface;
      if (error.action && error.action.payload) {
        const { status } = error.action.payload;
        // If 401 status, redirect to sign-in
        if (status === HTTP_STATUS.SC_UNAUTHORIZED) {
          window.location = getSignInPage();
          return null;
        }
        // If 400 status, redirect to /rental-manager/properties.
        if (status === HTTP_STATUS.SC_BAD_REQUEST) {
          window.location.href = paths.landlordPropertyPage;
          return null;
        }
      }
      logError({ error: err });
      dispatch(showPageNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
